import { cx } from '@linaria/core';
import { TransitionGroup } from 'react-transition-group';
import { speechButtonSelectors } from '@ui/kit/selectors';
import { CSSRefTransition } from '@utils/react';
import { iconCls, labelCls, TEXT_FADE_DURATION_MS, outlineCls, buttonCls } from './styles/ExpandCollapseButton.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function ExpandCollapseButton({
  isExpanded,
  isTransitioning,
  expand,
  collapse
}) {
  // The isExpanded prop specifies whether or not the component is fully
  // expanded, but we need to know which state the component is at or
  // transitioning towards to be able to trigger transitions as soon as a
  // transitiong begins
  const isOrIsTowardsCollapsed = !isExpanded && !isTransitioning || isExpanded && isTransitioning;
  const isOrIsTowardsExpanded = isExpanded && !isTransitioning || !isExpanded && isTransitioning;
  return /*#__PURE__*/jsxs("button", {
    className: cx(speechButtonSelectors.textComponentToggleButton.className, buttonCls),
    onClick: isExpanded ? collapse : expand,
    children: [/*#__PURE__*/jsx("i", {
      className: cx(iconCls, isOrIsTowardsCollapsed && "collapsed", isOrIsTowardsExpanded && "expanded")
    }), /*#__PURE__*/jsx("span", {
      className: labelCls,
      children: /*#__PURE__*/jsx(TransitionGroup, {
        component: null,
        children: /*#__PURE__*/jsx(CSSRefTransition, {
          timeout: TEXT_FADE_DURATION_MS,
          classNames: labelCls,
          children: ref => /*#__PURE__*/jsxs("span", {
            ref: ref,
            className: outlineCls,
            children: [isOrIsTowardsCollapsed && "Læs mere", isOrIsTowardsExpanded && "Læs mindre"]
          })
        }, `expandButtonText-${isOrIsTowardsExpanded}-${isOrIsTowardsExpanded}`)
      })
    })]
  });
}

export { ExpandCollapseButton };
//# sourceMappingURL=ExpandCollapseButton.js.map
